
const socket = {};
socket.emit = function(req) {

    const host = (window.location.href.includes("migratie")) ? "migratie.geefirm.com" : "studious-vector-219115.appspot.com" ;

    const service = {
        transporter: "https",
        //host: "studious-vector-219115.appspot.com",
        //port: "443",
        //host: "migratie.geefirm.com",
        //port: "5001",
        host,
        port: "443", 
        path: "/"
    };

    const transporter = require("https"); // https!

    return new Promise((resolve, reject) => {

        const options = {
            host: service.host,
            port: service.port,
            path: service.path, 
            method: 'POST',
            headers: {
                'Content-Type': 'application/json' 
                //authorization: "req.headers.authorization"
            }
        };

        let txt = '';
        try {
            const tp = transporter.request(options, (res) => {
                res.setEncoding('utf8');
                res.on('data', (chunk) => {
                    txt += chunk;
                });
                res.on('end', () => {
                    //console.log("+++ Server.res.txt", txt);
                    const resjson = JSON.parse(txt)
                    resolve(resjson)
                });
            });
            //console.log("req to server")
            tp.write(JSON.stringify(req));
            tp.end();
        }
        catch (err) {
            resolve(txt)
        }
    });

}

export function reqEndpoint (req) {return socket.emit(req)} 




// WEBPACK FOOTER //
// ./src/Server.js